var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var Changeable = require("../mixins/changeable.jsx");

var _require = require("../icon-paths.js"),
    iconOk = _require.iconOk;

var InlineIcon = require("../components/inline-icon.jsx");
var Renderer = require("../renderer.jsx");
var Util = require("../util.js");

var _require2 = require("../gorgon/proptypes.js"),
    linterContextProps = _require2.linterContextProps,
    linterContextDefault = _require2.linterContextDefault;

var Sequence = React.createClass({
    displayName: "Sequence",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        json: React.PropTypes.arrayOf(React.PropTypes.shape({
            content: React.PropTypes.string,
            images: React.PropTypes.object,
            widgets: React.PropTypes.object
        })),
        trackInteraction: React.PropTypes.func.isRequired,
        linterContext: linterContextProps
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            json: [{
                content: "",
                widgets: {},
                images: {}
            }],
            linterContext: linterContextDefault
        };
    },

    getInitialState: function getInitialState() {
        return {
            visible: 1
        };
    },

    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        return nextProps !== this.props || nextState !== this.state;
    },

    render: function render() {
        var _this = this;

        var icon = React.createElement(InlineIcon, _extends({}, iconOk, { style: { color: "green" } }));

        var content = _.chain(this.props.json).first(this.state.visible).map(function (step, i) {
            return "[[" + Util.snowman + " group " + i + "]]";
        }).join("\n\n").value();

        var widgets = {};
        _.each(this.props.json, function (step, i) {
            var widgetId = "group " + i;
            widgets[widgetId] = {
                type: "group",
                graded: true,
                version: { major: 0, minor: 0 },
                options: _.extend({}, step, {
                    icon: i < _this.state.visible - 1 ? icon : null
                })
            };
        });

        return React.createElement(
            "div",
            { className: "perseus-sequence" },
            React.createElement(Renderer, {
                ref: "renderer",
                content: content,
                widgets: widgets,
                onInteractWithWidget: this._handleInteraction,
                apiOptions: this.props.apiOptions,
                linterContext: this.props.linterContext
            })
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    _handleInteraction: function _handleInteraction(groupWidgetId) {
        var step = parseInt(groupWidgetId.split(" ")[1]);
        if (step === this.state.visible - 1) {
            var widget = this.refs.renderer.getWidgetInstance("group " + step);

            widget.showRationalesForCurrentlySelectedChoices();
            var score = widget.simpleValidate();

            if (score.type === "points" && score.total === score.earned) {
                this.setState({
                    visible: this.state.visible + 1
                });
                this.props.trackInteraction({
                    visible: this.state.visible + 1
                });
            }
        }
    }
});

var traverseChildWidgets = function traverseChildWidgets(props, traverseRenderer) {
    var oldJson = props.json;
    if (!_.isArray(oldJson)) {
        oldJson = [oldJson];
    }
    var json = _.map(oldJson, function (rendererOptions) {
        return traverseRenderer(rendererOptions);
    });

    return _.extend({}, props, { json: json });
};

module.exports = {
    name: "sequence",
    displayName: "Graded Sequence",
    widget: Sequence,
    traverseChildWidgets: traverseChildWidgets,
    tracking: "all",
    hidden: true,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/sequence.jsx
 ** module id = 144
 ** module chunks = 0 1
 **/